import React, { Component } from 'react'
import Firebase from './Firebase';
export class AdminEdit extends Component {
    constructor(props) {
        super(props);
        this.tb = Firebase.firestore().collection('SSR');
        this.tb2 = Firebase.firestore().collection('SSUREE');
        this.state = {
            dataold: [],
            datanew: []
        }
    }

    componentDidMount() {
        this.tb.onSnapshot(this.listDataOld)
    }
    listDataOld = (querySnapshot) => {
        const dataold = [];
        const datanew = [];
        querySnapshot.forEach((doc) => {
            const { Answer, Sex, Age, Role, Create_date, Suggestion } = doc.data();

            let temp_ans = [];

            Answer.forEach((element, i) => {
                temp_ans[i] = 6 - element;
            })
            dataold.push(Answer);
            datanew.push(temp_ans);
            // this.tb2.add({
            //     Sex, Age, Role, Create_date, Suggestion,
            //     Answer: temp_ans
            // }).then(() => {
            //     console.log("success");
            // }).catch((error) => {
            //     console.log(error)
            // })
        })

        this.setState({
            dataold,
            datanew
        })
    }
    render() {
        return (
            <div>
                <table>
                    <tr>
                        <th>Company</th>
                        <th>Contact</th>
                        <th>Country</th>
                    </tr>

                    <tr>
                        {/* <td>{this.state.dataold.map((element) => element + ",")}</td>
                        <td>{this.state.datanew.map((element) => element + ",")}</td> */}
                    </tr>

                </table>
            </div>
        )
    }
}

export default AdminEdit
